const SET_USERS = (state, users) => {
    state.users = users;
}
const INCREMENT = (state) =>{
    state.count += 1 
}
export {
    SET_USERS,
    INCREMENT
}